import { mlbOutcomes } from "./LandingDemoData"
import { LandingDemoNFLBracket as BaseBracket } from "./LandingDemoNFLBracket"

type Props = Parameters<typeof BaseBracket>[0]

export function LandingDemoMLBBracket(
  props: Omit<
    Props,
    "title" | "outcomes" | "imageUrl" | "volume" | "progress" | "ends" | "dateStart" | "dateEnd" | "state" | "simulate"
  >,
) {
  return (
    <BaseBracket
      title="2025 MLB World Series"
      outcomes={mlbOutcomes}
      imageUrl="https://a.bracky.app/assets/covers/mlb/world-series.webp"
      volume={450000}
      progress={15}
      ends={new Date("2025-11-15")}
      dateStart={new Date("2025-03-15")}
      dateEnd={new Date("2025-11-15")}
      state="live"
      simulate
      {...props}
    />
  )
}
